'use client';

import { AlertUsers } from '@/components/AlertUsers';
import { ReplaceInPersonForm } from './components/ReplaceInPersonForm';

export default function Page() {
	return (
		<section className="flex grow flex-col">
			<AlertUsers />
			<ReplaceInPersonForm />
		</section>
	);
}
